import Core from "@/modules/core/service/Core";

const url = {
    assessments : "/api/incident/assessments/{0}",
};

export default {
    ratings     : {
        DANGER: {
            rank : 1,
            color: "error",
        },
        MAJOR: {
            rank : 2,
            color: "warning",
        },
        MINOR: {
            rank : 3,
            color: "primary",
        },
        VALID: {
            rank : 5,
            color: null,
        },
        NOTICE: {
            rank : 5,
            color: "lm-border primary--text pl-0",
        }
    },

    ratingName (rating) {
        if (typeof rating === 'string' || rating instanceof String) {
            return rating;
        } else {
            return rating.name;
        }
    },

    list (siteId, success) {
        return Core.method.get(url.assessments, siteId).then((data => success(data)));
    },

    update (assessment, success) {
        return Core.method.put(url.assessments, assessment, assessment.siteId).then((data) => success (data));
    }
}